import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Divider,
  Chip,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { investorApi, vendorApi } from "../../../api/api";
 
const YourApartmentPlotsImages = ({ propertyData, onEditClick }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);
 
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
 
  // ✅ propertyData IS OBJECT
  const apartment = propertyData;
  // console.log(apartment);
  // debugger
  useEffect(() => {
    if (apartment?.id) {
      getImages();
    }
  }, [apartment?.id]);
 
  const getImages = async () => {
    try {
      const response = await investorApi.getApartmentImagesById(apartment.id);
      setImages(response?.data || []);
    } catch (error) {
      console.error("Failed to fetch images", error);
      setImages([]);
    }
  };
 
  const openModal = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };
 
  const closeModal = () => setModalOpen(false);
 
  const goPrev = () =>
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
 
  const goNext = () =>
    setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
 
  // const handleDelete = async (imageId) => {
  //   if (!window.confirm("Are you sure you want to delete this image?")) return;
 
  //   try {
  //     await vendorApi.deleteImageById({
  //       id: imageId,
  //       type: apartment?.type,
  //     });
  //     setImages((prev) => prev.filter((img) => img.Id !== imageId));
  //   } catch (error) {
  //     alert("Failed to delete image");
  //   }
  // };
 
  return (
    <>
      {/* ================= MAIN LAYOUT ================= */}
      <Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={4}>
        {/* ================= LEFT SIDE (IMAGE + STATUS) ================= */}
        <Box
          sx={{
            width: isMobile ? "100%" : "40%",
            height: "60vh",
            position: "relative",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 4,
            cursor: "pointer",
           
          }}
          onClick={() => openModal(0)}
        >
          {apartment?.iconUrl ? (
            <Box
              component="img"
              src={apartment.iconUrl}
              alt="Apartment"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "grey.100",
              }}
            >
              <Typography align="center" variant="h6" color="text.secondary">
                No Image Available
              </Typography>
            </Box>
          )}
          {/* STATUS */}
          <Chip
            label={apartment?.Status || "Pending"}
            color={apartment?.Status === "Approved" ? "success" : "warning"}
            sx={{
              position: "absolute",
              top: 16,
              left: 16,
              fontWeight: 600,
            }}
          />
 
          {/* DELETE */}
          {/* {images?.[0]?.Id && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(images[0].Id);
              }}
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                bgcolor: "rgba(255,255,255,0.9)",
                "&:hover": { bgcolor: "rgba(255,255,255,1)" },
              }}
            >
              <DeleteIcon color="error" />
            </IconButton>
          )} */}
        </Box>
 
        {/* ================= RIGHT SIDE (DETAILS) ================= */}
        <Box sx={{ width: isMobile ? "100%" : "60%", py: 2,  padding:"10px" }}>
          {/* HEADER WITH ICON, NAME AND EDIT BUTTON */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
              flexWrap: "wrap",
              gap: 2,
             
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <ApartmentIcon
                sx={{
                  fontSize: 32,
                  color: "primary.main",
                }}
              />
              <Typography variant="h5" fontWeight={700}>
                {apartment?.name}
              </Typography>
            </Box>
 
            {/* EDIT BUTTON */}
            {/* <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={onEditClick}
              sx={{
                bgcolor: "primary.main",
                "&:hover": {
                  bgcolor: "primary.dark",
                },
              }}
            >
              Edit Details
            </Button> */}
          </Box>
 
          <Divider sx={{ my: 2 }} />
 
          {/* DETAILS GRID */}
          {/* DETAILS GRID */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
              gap: 2,
            }}
          >
            {/* Address */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Address
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.address || "N/A"}
              </Typography>
            </Box>
 
            {/* City */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                City
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.city || "N/A"}
              </Typography>
            </Box>
 
            {/* Property Type */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Property Type
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.type || "N/A"}
              </Typography>
            </Box>
 
            {/* Total Floors */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Total Floors
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.TotalFloors || "N/A"}
              </Typography>
            </Box>
 
            {/* ✅ NEW: Land Area */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Land Area
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.LandArea || "N/A"}
              </Typography>
            </Box>
 
            {/* ✅ NEW: Construction Status */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Construction Status
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.Construction_Status || "N/A"}
              </Typography>
            </Box>
 
            {/* ✅ NEW: Total Blocks */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Total Blocks
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.TotalBlocks || "N/A"}
              </Typography>
            </Box>
 
            {/* ✅ NEW: Total Units */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Total No of Flats
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.TotalUnits || "N/A"}
              </Typography>
            </Box>
 
            {/* Total Flats */}
            {/* <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Total Flats
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {apartment?.flats?.length || 0}
              </Typography>
            </Box> */}
 
            {/* Description */}
            {apartment?.description && (
              <Box sx={{ gridColumn: isMobile ? "1" : "1 / span 2" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Description
                </Typography>
                <Typography variant="body1" sx={{ mt: 0.5 }}>
                  {apartment.description}
                </Typography>
              </Box>
            )}
          </Box>
 
        </Box>
      </Box>
 
      {/* ================= IMAGE MODAL ================= */}
      <Modal open={modalOpen} onClose={closeModal}>
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={closeModal}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              color: "#fff",
              bgcolor: "rgba(0,0,0,0.5)",
              "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
            }}
          >
            <CloseIcon fontSize="large" />
          </IconButton>
 
          <IconButton
            onClick={goPrev}
            sx={{
              position: "absolute",
              left: 40,
              color: "#fff",
              bgcolor: "rgba(0,0,0,0.5)",
              "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
            }}
          >
            <ChevronLeftIcon fontSize="large" />
          </IconButton>
 
          {images[currentIndex] && (
            <Box
              component="img"
              src={images[currentIndex].ImageURL}
              alt={`Image ${currentIndex + 1}`}
              sx={{
                maxWidth: "90%",
                maxHeight: "90%",
                objectFit: "contain",
              }}
            />
          )}
 
          <IconButton
            onClick={goNext}
            sx={{
              position: "absolute",
              right: 40,
              color: "#fff",
              bgcolor: "rgba(0,0,0,0.5)",
              "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
            }}
          >
            <ChevronRightIcon fontSize="large" />
          </IconButton>
 
          <Typography
            sx={{
              position: "absolute",
              bottom: 20,
              color: "#fff",
              bgcolor: "rgba(0,0,0,0.5)",
              px: 2,
              py: 1,
              borderRadius: 1,
            }}
          >
            {currentIndex + 1} / {images.length}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};
 
export default YourApartmentPlotsImages;